/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TranslateModule} from '@ngx-translate/core';

import {AsideComponent} from './aside/aside.component';
import {DropdownComponent, MenuDropdownService} from './aside/dropdown/dropdown.component';
import {MenuItemComponent} from './aside/menu-item/menu-item.component';
import {MenuComponent} from './aside/menu/menu.component';
import {ContextBarComponent} from './navbar/context-bar/context-bar.component';
import {ContextPayTypeComponent} from './navbar/context-bar/context-pay-type/context-pay-type.component';
import {ContextPopulationComponent} from './navbar/context-bar/context-population/context-population.component';
import {DropdownDirective} from './navbar/dropdown.directive';
import {NavbarComponent} from './navbar/navbar.component';

import {MomentModule} from 'ngx-moment';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {ESSService} from '../+ess/employee-self.service';
import {DashboardModule} from '../dashboard/dashboard.module';
import {InboxModule} from '../inbox/inbox.module';
import {MeModule} from '../me/me.module';
import {KeycloakWrapperService} from '../shared/authentication/keycloak-wrapper.service';
import {ModalModule} from '../shared/modal/modal.module';
import {PipesModule} from '../shared/pipes/pipes.module';
import {UiModule} from '../shared/ui/ui.module';
import {UserModule} from '../shared/user/user.module';
import {WorkflowV2Module} from '../shared/workflow/workflow-v2.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule,
    RouterModule,
    UserModule,
    ModalModule,
    TranslateModule,
    DashboardModule,
    InboxModule,
    UiModule,
    PipesModule,
    WorkflowV2Module,
    MeModule,
    PopoverModule.forRoot()
  ],
  declarations: [
    DropdownComponent,
    MenuItemComponent,
    AsideComponent,
    MenuComponent,
    NavbarComponent,
    DropdownDirective,
    ContextBarComponent,
    ContextPayTypeComponent,
    ContextPopulationComponent
  ],
  exports: [
    DropdownComponent,
    MenuItemComponent,
    AsideComponent,
    MenuComponent,
    NavbarComponent,
    DropdownDirective
  ],
  providers: [
    MenuDropdownService,
    ESSService,
    KeycloakWrapperService
  ]
})
export class NavigationModule {
}
